import createAxios from '@/app/core/AxiosCore';
import config from '@/app/config/app';
import qs from "qs";

const axios = createAxios(config);

function list() {
  return axios.get(`emitentes`)
    .then(response => response.data);
}

function store(emitente) {
  return axios.post(`emitentes`, emitente)
    .then(response => response.data);
}

function show(emitente) {
  return axios.get(`emitentes/${emitente.id}`)
    .then(response => response.data);
}

async function emitente() {
  return await axios.get(`emitente`);
}

function update(emitente) {
  return axios.put(`emitentes/${emitente.id}`, emitente)
    .then(response => response.data);
}

function destroy(id) {
  return axios.delete(`emitentes/${id}`)
    .then(response => response.data);
}


export default {
  list,
  store,
  show,
  emitente,
  update,
  destroy
}
